export function PageContent({ children }: { children: React.ReactNode }) {
  return (
      <div className="flex flex-col px-5 py-6">
        {children}
      </div>
  )
}